// January (1–25)
import gallery1 from "../../Assets/Gallery/jan/gallery1.jpg";
import gallery2 from "../../Assets/Gallery/jan/gallery2.jpg";
import gallery3 from "../../Assets/Gallery/jan/gallery3.jpg";
import gallery4 from "../../Assets/Gallery/jan/gallery4.jpg";
import gallery5 from "../../Assets/Gallery/jan/gallery5.jpg";
import gallery6 from "../../Assets/Gallery/jan/gallery6.jpg";
import gallery7 from "../../Assets/Gallery/jan/gallery7.jpg";
import gallery8 from "../../Assets/Gallery/jan/gallery8.jpg";
import gallery9 from "../../Assets/Gallery/jan/gallery9.jpg";
import gallery10 from "../../Assets/Gallery/jan/gallery10.jpg";
import gallery11 from "../../Assets/Gallery/jan/gallery11.jpg";
import gallery12 from "../../Assets/Gallery/jan/gallery12.jpg";
import gallery13 from "../../Assets/Gallery/jan/gallery13.jpg";
import gallery14 from "../../Assets/Gallery/jan/gallery14.jpg";
import gallery15 from "../../Assets/Gallery/jan/gallery15.jpg";
import gallery16 from "../../Assets/Gallery/jan/gallery16.jpg";
import gallery17 from "../../Assets/Gallery/jan/gallery17.jpg";
import gallery18 from "../../Assets/Gallery/jan/gallery18.jpg";
import gallery19 from "../../Assets/Gallery/jan/gallery19.jpg";
import gallery20 from "../../Assets/Gallery/jan/gallery20.jpg";
import gallery21 from "../../Assets/Gallery/jan/gallery21.jpg";
import gallery22 from "../../Assets/Gallery/jan/gallery22.jpg";
import gallery23 from "../../Assets/Gallery/jan/gallery23.jpg";
import gallery24 from "../../Assets/Gallery/jan/gallery24.jpg";
import gallery25 from "../../Assets/Gallery/jan/gallery25.jpg";

// February (26–48)
import gallery26 from "../../Assets/Gallery/feb/gallery26.jpg";
import gallery27 from "../../Assets/Gallery/feb/gallery27.jpg";
import gallery28 from "../../Assets/Gallery/feb/gallery28.jpg";
import gallery29 from "../../Assets/Gallery/feb/gallery29.jpg";
import gallery30 from "../../Assets/Gallery/feb/gallery30.jpg";
import gallery31 from "../../Assets/Gallery/feb/gallery31.jpg";
import gallery32 from "../../Assets/Gallery/feb/gallery32.jpg";
import gallery33 from "../../Assets/Gallery/feb/gallery33.jpg";
import gallery34 from "../../Assets/Gallery/feb/gallery34.jpg";
import gallery35 from "../../Assets/Gallery/feb/gallery35.jpg";
import gallery36 from "../../Assets/Gallery/feb/gallery36.jpg";
import gallery37 from "../../Assets/Gallery/feb/gallery37.jpg";
import gallery38 from "../../Assets/Gallery/feb/gallery38.jpg";
import gallery39 from "../../Assets/Gallery/feb/gallery39.jpg";
import gallery40 from "../../Assets/Gallery/feb/gallery40.jpg";
import gallery41 from "../../Assets/Gallery/feb/gallery41.jpg";
import gallery42 from "../../Assets/Gallery/feb/gallery42.jpg";
import gallery43 from "../../Assets/Gallery/feb/gallery43.jpg";
import gallery44 from "../../Assets/Gallery/feb/gallery44.jpg";
import gallery45 from "../../Assets/Gallery/feb/gallery45.jpg";
import gallery46 from "../../Assets/Gallery/feb/gallery46.jpg";
import gallery47 from "../../Assets/Gallery/feb/gallery47.jpg";
import gallery48 from "../../Assets/Gallery/feb/gallery48.jpg";

// March (49–56)
import gallery49 from "../../Assets/Gallery/march/gallery49.jpg";
import gallery50 from "../../Assets/Gallery/march/gallery50.jpg";
import gallery51 from "../../Assets/Gallery/march/gallery51.jpg";
import gallery52 from "../../Assets/Gallery/march/gallery52.jpg";
import gallery53 from "../../Assets/Gallery/march/gallery53.jpg";
import gallery54 from "../../Assets/Gallery/march/gallery54.jpg";
import gallery55 from "../../Assets/Gallery/march/gallery55.jpg";
import gallery56 from "../../Assets/Gallery/march/gallery56.jpg";

// April (57–65)
import gallery57 from "../../Assets/Gallery/apr/gallery57.jpg";
import gallery58 from "../../Assets/Gallery/apr/gallery58.jpg";
import gallery59 from "../../Assets/Gallery/apr/gallery59.jpg";
import gallery60 from "../../Assets/Gallery/apr/gallery60.jpg";
import gallery61 from "../../Assets/Gallery/apr/gallery61.jpg";
import gallery62 from "../../Assets/Gallery/apr/gallery62.jpg";
import gallery63 from "../../Assets/Gallery/apr/gallery63.jpg";
import gallery64 from "../../Assets/Gallery/apr/gallery64.jpg";
import gallery65 from "../../Assets/Gallery/apr/gallery65.jpg";

// Augest 
import gallery66 from "../../Assets/Gallery/aug/gallery66.jpg";
import gallery67 from "../../Assets/Gallery/aug/gallery67.jpg";
import gallery68 from "../../Assets/Gallery/aug/gallery68.jpg";
import gallery69 from "../../Assets/Gallery/aug/gallery69.jpg";
import gallery70 from "../../Assets/Gallery/aug/gallery70.jpg";
import gallery71 from "../../Assets/Gallery/aug/gallery71.jpg";
import gallery72 from "../../Assets/Gallery/aug/gallery72.jpg";
import gallery73 from "../../Assets/Gallery/aug/gallery73.jpg";
import gallery74 from "../../Assets/Gallery/aug/gallery74.jpg";
import gallery75 from "../../Assets/Gallery/aug/gallery75.jpg";


// Data
const gallerydata = [
  { image: gallery1, month: "January", year: 2025 },
  { image: gallery2, month: "January", year: 2025 },
  { image: gallery3, month: "January", year: 2025 },
  { image: gallery4, month: "January", year: 2025 },
  { image: gallery5, month: "January", year: 2025 },
  { image: gallery6, month: "January", year: 2025 },
  { image: gallery7, month: "January", year: 2025 },
  { image: gallery8, month: "January", year: 2025 },
  { image: gallery9, month: "January", year: 2025 },
  { image: gallery10, month: "January", year: 2025 },
  { image: gallery11, month: "January", year: 2025 },
  { image: gallery12, month: "January", year: 2025 },
  { image: gallery13, month: "January", year: 2025 },
  { image: gallery14, month: "January", year: 2025 },
  { image: gallery15, month: "January", year: 2025 },
  { image: gallery16, month: "January", year: 2025 },
  { image: gallery17, month: "January", year: 2025 },
  { image: gallery18, month: "January", year: 2025 },
  { image: gallery19, month: "January", year: 2025 },
  { image: gallery20, month: "January", year: 2025 },
  { image: gallery21, month: "January", year: 2025 },
  { image: gallery22, month: "January", year: 2025 },
  { image: gallery23, month: "January", year: 2025 },
  { image: gallery24, month: "January", year: 2025 },
  { image: gallery25, month: "January", year: 2025 },

  { image: gallery26, month: "February", year: 2025 },
  { image: gallery27, month: "February", year: 2025 },
  { image: gallery28, month: "February", year: 2025 },
  { image: gallery29, month: "February", year: 2025 },
  { image: gallery30, month: "February", year: 2025 },
  { image: gallery31, month: "February", year: 2025 },
  { image: gallery32, month: "February", year: 2025 },
  { image: gallery33, month: "February", year: 2025 },
  { image: gallery34, month: "February", year: 2025 },
  { image: gallery35, month: "February", year: 2025 },
  { image: gallery36, month: "February", year: 2025 },
  { image: gallery37, month: "February", year: 2025 },
  { image: gallery38, month: "February", year: 2025 },
  { image: gallery39, month: "February", year: 2025 },
  { image: gallery40, month: "February", year: 2025 },
  { image: gallery41, month: "February", year: 2025 },
  { image: gallery42, month: "February", year: 2025 },
  { image: gallery43, month: "February", year: 2025 },
  { image: gallery44, month: "February", year: 2025 },
  { image: gallery45, month: "February", year: 2025 },
  { image: gallery46, month: "February", year: 2025 },
  { image: gallery47, month: "February", year: 2025 },
  { image: gallery48, month: "February", year: 2025 },

  { image: gallery49, month: "March", year: 2025 },
  { image: gallery50, month: "March", year: 2025 },
  { image: gallery51, month: "March", year: 2025 },
  { image: gallery52, month: "March", year: 2025 },
  { image: gallery53, month: "March", year: 2025 },
  { image: gallery54, month: "March", year: 2025 },
  { image: gallery55, month: "March", year: 2025 },
  { image: gallery56, month: "March", year: 2025 },

  { image: gallery57, month: "April", year: 2025 },
  { image: gallery58, month: "April", year: 2025 },
  { image: gallery59, month: "April", year: 2025 },
  { image: gallery60, month: "April", year: 2025 },
  { image: gallery61, month: "April", year: 2025 },
  { image: gallery62, month: "April", year: 2025 },
  { image: gallery63, month: "April", year: 2025 },
  { image: gallery64, month: "April", year: 2025 },
  { image: gallery65, month: "April", year: 2025 },

  { image: gallery66, month: "August", year: 2025 },
  { image: gallery67, month: "August", year: 2025 },
  { image: gallery68, month: "August", year: 2025 },
  { image: gallery69, month: "August", year: 2025 },
  { image: gallery70, month: "August", year: 2025 },
  { image: gallery71, month: "August", year: 2025 },
  { image: gallery72, month: "August", year: 2025 },
  { image: gallery73, month: "August", year: 2025 },
  { image: gallery74, month: "August", year: 2025 },
  { image: gallery75, month: "August", year: 2025 },
];

export default gallerydata;
